module.exports = __webpack_public_path__ + "media/img/careers/why-work/why-work-photo4-4a0f6e0dedb992d7c3ba6fda84f23621.jpg";